/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodWareDishIcon16Light } from './FoodWareDishIcon16Light';
import { FoodWareDishIcon16Regular } from './FoodWareDishIcon16Regular';
import { FoodWareDishIcon16Solid } from './FoodWareDishIcon16Solid';
import { FoodWareDishIcon20Light } from './FoodWareDishIcon20Light';
import { FoodWareDishIcon20Regular } from './FoodWareDishIcon20Regular';
import { FoodWareDishIcon20Solid } from './FoodWareDishIcon20Solid';
import { FoodWareDishIcon24Regular } from './FoodWareDishIcon24Regular';
import { FoodWareDishIcon24Solid } from './FoodWareDishIcon24Solid';
import { FoodWareDishIcon32Regular } from './FoodWareDishIcon32Regular';
import { FoodWareDishIcon64Regular } from './FoodWareDishIcon64Regular';
var sizes = {
    16: {
        light: FoodWareDishIcon16Light,
        regular: FoodWareDishIcon16Regular,
        solid: FoodWareDishIcon16Solid,
    },
    20: {
        light: FoodWareDishIcon20Light,
        regular: FoodWareDishIcon20Regular,
        solid: FoodWareDishIcon20Solid,
    },
    24: {
        regular: FoodWareDishIcon24Regular,
        solid: FoodWareDishIcon24Solid,
    },
    32: {
        regular: FoodWareDishIcon32Regular,
    },
    64: {
        regular: FoodWareDishIcon64Regular,
    },
};
export var FoodWareDishIcon = forwardRef('FoodWareDishIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
